export const userTypes = {
  OWNER: "owner",
  INDIVIDUAL: "individual",
  DEVELOPER: "developer",
};

export const CURRENCY = {
  MXN: "MXN",
  USD: "USD",
};

export const FEES = {
  GENERAL: "2.9%",
  THREE_MONTHS_INTEREST_FREE: "3.95%",
  SIX_MONTHS_INTEREST_FREE: "6.5%",
  NINE_MONTHS_INTEREST_FREE: "9%",
  TWELVE_MONTHS_INTEREST_FREE: "12%",
};

export const HEADER_HEIGHT = 80;
export const DRAWER_WIDTH = 290;
export const CHAT_HEIGHT = 62;
export const AUTH_CONTAINER_WIDTH = 564;
export const AUTH_TITLE_SPACE = 6;
export * from "./appOwner";
export * from "./moduleComponents.constants";

export const SESSION_EXPIRED_ERROR = "session-expired";
export const SESSION_EXPIRATION_TIME = 30 * 60 * 1000; // 30 minutes

export const ZIP_CODE_LENGTH = 5;
export const PHONE_LENGTH = 10;

export const TOAST_AUTO_CLOSE = 10000;

export const RECOVER_PASS_TOKEN_EXPIRATION_TIME = 60 * 60 * 1000; // 60 minutes

export const FUNDS_AUTO_UPDATE_TIME_INTERVAL = 1000 * 60 * 10; // 10 min
export const FUNDS_PROPERTY_NAME = "cachedFunds";
